var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-lines */
import React, { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { Sidepanel } from "../../../../Components/UI/Sidepanel";
import { t, Translate } from "../../../../../I18N";
import { Button } from "../../../../Components/UI/Button";


import { propertyIcons } from "../../../../Components/UI/Icons";
import { useAtomValue } from 'jotai';
import { templatesAtom } from "../../../../atoms";
import {
  PropertyTypeField,
  LabelField,
  HideLabelField,
  RequiredField,
  ShowInCardsField,
  DefaultFilterField,
  PrioritySortingField,
  FilterField,
  StyleField,
  FullWidthField } from "./fields";

import { ThesaurusField } from "./fields/ThesaurusField";
import { RelationshipFields } from "./fields/RelationshipFields";
import { MatchingPropertiesTable } from "./MatchingPropertiesTable";
import { translationsKeys } from "../helpers";

import { GeneratedIdField } from "./fields/GeneratedIdField";









const emptyProperty = {
  type: 'text',
  label: 'Text',
  noLabel: false,
  required: false,
  showInCard: false,
  filter: false,
  defaultfilter: false,
  prioritySorting: false,
  style: '',
  content: undefined,
  relationType: undefined,
  inherit: undefined,
  generatedId: false
};

const filterableTypes = [
'text',
'numeric',
'select',
'relationship',
'multiselect',
'date',
'daterange',
'multidate',
'multidaterange',
'markdown',
'generatedid',
'nested'];


const prioritySortingTypes = ['text', 'numeric', 'select', 'date'];
const fullWidthTypes = ['image', 'preview', 'media'];

export const ConfigPropertyPanel = ({
  isOpen,
  onClose,
  onSubmit,
  template,
  propertyToEdit
}) => {
  const templates = useAtomValue(templatesAtom);
  const form = useForm({
    defaultValues: propertyToEdit ?
    {
      type: propertyToEdit.type,
      label: propertyToEdit.label || '',
      noLabel: propertyToEdit.noLabel || false,
      required: propertyToEdit.required || false,
      showInCard: propertyToEdit.showInCard || false,
      filter: propertyToEdit.filter || false,
      defaultfilter: propertyToEdit.defaultfilter || false,
      prioritySorting: propertyToEdit.prioritySorting || false,
      style: propertyToEdit.style || '',
      content: propertyToEdit.content || '',
      relationType: propertyToEdit.relationType || '',
      inherit: propertyToEdit.inherit,
      generatedId: propertyToEdit.generatedId || false
    } : _objectSpread({},
    emptyProperty)
  });

  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
    watch,
    setValue,
    reset
  } = form;

  const type = watch('type');
  const filter = watch('filter');
  const label = watch('label');
  const content = watch('content');
  const relationType = watch('relationType');
  const inherit = watch('inherit');
  const isCommonProperty = propertyToEdit === null || propertyToEdit === void 0 ? void 0 : propertyToEdit.isCommonProperty;
  const isTitleProperty = (propertyToEdit === null || propertyToEdit === void 0 ? void 0 : propertyToEdit.name) === 'title';

  const isSelectOrMultiselect = type === 'select' || type === 'multiselect';
  const isImageOrPreview = type === 'image' || type === 'preview';
  const isRelationship = type === 'relationship';

  // eslint-disable-next-line max-statements
  useEffect(() => {
    if (!propertyToEdit) {
      reset(_objectSpread(_objectSpread({}, emptyProperty), {}, { type, label: type.charAt(0).toUpperCase() + type.slice(1) }));
      if (type === 'image' || type === 'preview') {
        setValue('style', 'fill');
      }
      if (type === 'relationship') {
        setValue('relationType', '');
        setValue('content', '');
      }
    }
    if (propertyToEdit) {
      reset(propertyToEdit);
    }
  }, [type, setValue, propertyToEdit, reset]);

  useEffect(() => {
    if (!isOpen) {
      reset(emptyProperty);
    }
  }, [reset, isOpen]);

  useEffect(() => {
    if (!filter && !isCommonProperty) {
      setValue('defaultfilter', false);
      setValue('prioritySorting', false);
    }
  }, [filter, setValue, isCommonProperty]);

  // eslint-disable-next-line max-statements
  const validateMatchingProperties = () => {
    const lowerLabel = label.trim().toLowerCase();

    const matchingProperties = templates.flatMap((templ) =>
    [...(templ.properties || [])].
    filter((prop) => {var _prop$label;return ((_prop$label = prop.label) === null || _prop$label === void 0 ? void 0 : _prop$label.trim().toLowerCase()) === lowerLabel;}).
    filter((prop) => prop._id !== (propertyToEdit === null || propertyToEdit === void 0 ? void 0 : propertyToEdit._id))
    );

    if (matchingProperties.length === 0) {
      return true;
    }

    const hasTypeMismatch = matchingProperties.some((prop) => prop.type !== type);
    if (hasTypeMismatch) {
      return false;
    }

    if (type === 'select' || type === 'multiselect') {
      const hasContentMismatch = matchingProperties.some(
        (prop) => prop.content !== content
      );
      if (hasContentMismatch) {
        return false;
      }
    }

    if (type === 'relationship') {
      const hasRelationshipMismatch = matchingProperties.some(
        (prop) =>
        prop.content !== content ||
        prop.relationType !== relationType ||
        JSON.stringify(prop.inherit) !== JSON.stringify(inherit)
      );
      if (hasRelationshipMismatch) {
        return false;
      }
    }

    return true;
  };

  const submitForm = (data) => {
    if (Object.keys(errors).length > 0) {
      return;
    }

    if (validateMatchingProperties()) {
      onSubmit(data);
      onClose();
    }
  };

  return (/*#__PURE__*/
    _jsx(Sidepanel, {
      isOpen: isOpen,
      withOverlay: true,
      size: "large",
      title: /*#__PURE__*/
      _jsx(Translate, { className: "uppercase" }, void 0,
      propertyToEdit ? 'Edit property' : 'New property'
      ),

      closeSidepanelFunction: onClose }, void 0, /*#__PURE__*/

    React.createElement(FormProvider, form, /*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(submitForm), className: "flex flex-col h-full" }, void 0, /*#__PURE__*/
    _jsx(Sidepanel.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "space-y-6" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-4" }, void 0,
    propertyToEdit ? /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-2" }, void 0, /*#__PURE__*/
    _jsx("p", { className: "text-sm font-medium text-gray-700" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Type")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-2 bg-gray-50 rounded-lg px-4 py-2 w-full" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "w-5 h-5 text-gray-500" }, void 0,
    propertyIcons[type]
    ), /*#__PURE__*/
    _jsx("span", { className: "text-sm text-gray-700" }, void 0,
    t(
      'System',
      translationsKeys[type] || type,
      null,
      false
    )
    )
    )
    ) : /*#__PURE__*/

    _jsx(PropertyTypeField, { control: control }), /*#__PURE__*/

    _jsx(LabelField, {
      register: register,
      errors: errors,
      template: template,
      propertyToEdit: propertyToEdit }
    ),
    isImageOrPreview && /*#__PURE__*/_jsx(StyleField, { control: control }),

    isSelectOrMultiselect && /*#__PURE__*/_jsx(ThesaurusField, { control: control }),
    isRelationship && /*#__PURE__*/
    _jsx(RelationshipFields, { control: control, templateId: template._id }), /*#__PURE__*/

    _jsx("div", { className: "flex flex-col gap-2 mt-2" }, void 0,
    fullWidthTypes.includes(type) && /*#__PURE__*/_jsx(FullWidthField, { control: control }),
    !isCommonProperty && /*#__PURE__*/_jsx(HideLabelField, { control: control }),
    !isCommonProperty && /*#__PURE__*/_jsx(RequiredField, { control: control }),
    !isCommonProperty && /*#__PURE__*/_jsx(ShowInCardsField, { control: control }),
    !isCommonProperty && filterableTypes.includes(type) && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(FilterField, { control: control }),
    filter && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(DefaultFilterField, { control: control }),
    prioritySortingTypes.includes(type) && /*#__PURE__*/
    _jsx(PrioritySortingField, { control: control })

    )

    ),

    isCommonProperty && /*#__PURE__*/_jsx(PrioritySortingField, { control: control }),
    isCommonProperty && isTitleProperty && /*#__PURE__*/_jsx(GeneratedIdField, { control: control })
    )
    ),
    !isCommonProperty && /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("h3", { className: "text-sm font-semibold text-gray-700 mb-2" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Properties from other templates in the collection using the same label."

    )
    ), /*#__PURE__*/
    _jsx(MatchingPropertiesTable, {
      label: label,
      type: type,
      template: template,
      content: content,
      relationType: relationType,
      inherit: inherit,
      _id: propertyToEdit === null || propertyToEdit === void 0 ? void 0 : propertyToEdit._id }
    )
    )

    )
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "flex justify-end gap-2 p-4 border-t" }, void 0, /*#__PURE__*/
    _jsx(Button, { type: "button", styling: "outline", onClick: onClose }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { type: "submit", color: "success", disabled: !validateMatchingProperties() }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, propertyToEdit ? 'Save' : 'Add property')
    )
    )
    )
    )
    ));

};